import { toast } from "react-toastify";

interface IErrorOptions {
  autoClose?: number | false;
}

export const Toast = (function (autoClose) {
  let Methods = { error: null, success: null, info: null, warning: null };
  const TOAST_OPTIONS = { autoClose: 5000, hideProgressBar: false };

  Methods.error = function (error, providedError?, options?: IErrorOptions) {
    console.log(`%c${error}`, "font-size: 1.1em; color: orange");
    providedError &&
      console.log(
        `%c${providedError?.message || JSON.stringify(providedError)}`,
        "font-size: 1.1em; color: red"
      );
    toast.error(
      `${error}. ${
        providedError
          ? `\nAdditional information: ${providedError?.message || JSON.stringify(providedError)}`
          : ""
      }`,
      { ...TOAST_OPTIONS, ...(options || {}) }
    );
  };

  Methods.success = function (success) {
    toast.success(success, TOAST_OPTIONS);
  };

  Methods.info = function (info, options) {
    toast.info(info, { ...TOAST_OPTIONS, ...options });
  };

  Methods.warning = function (warning) {
    toast.warn(warning, TOAST_OPTIONS);
  };

  return Methods;
})();

export const generateToastErrors = (error: string | object, errorsTexts: object) => {
  typeof error === "string"
    ? Toast.error(errorsTexts, error)
    : Object.keys(error).map((key) =>
        Toast.error(errorsTexts[key] || error[key], null, { autoClose: false })
      );
};

export const generateToastFromObject = (error: object, baseText?: string) => {
  Toast.error(
    baseText || "",
    Object.keys(error).map((key) => error[key].join(", "))
  );
};
